import React from 'react';
import { X, Check } from 'lucide-react';
const comparisons = [{
  sin: '3-5 hs/semana buscando qué entrenar',
  con: '15 min/semana mirando la planilla'
}, {
  sin: 'Siempre los mismos ejercicios básicos',
  con: '50 ejercicios y drills listos para usar'
}, {
  sin: 'Charlas técnicas improvisadas',
  con: 'Guiones de charla listos para cada situación'
}, {
  sin: 'Sin planificación táctica clara',
  con: '4 sistemas de juego con roles explicados'
}, {
  sin: 'Jugadores que no ven progreso',
  con: 'Fichas de evaluación con 3 mediciones de temporada'
}, {
  sin: 'Conflictos sin saber cómo resolverlos',
  con: 'Guiones para las 6 situaciones de conflicto más comunes'
}, {
  sin: 'Sin registro de asistencia ni carga',
  con: 'Planilla de control semanal completa'
}, {
  sin: 'Llegar a la final sin pico de rendimiento',
  con: 'Calendario de temporada con fases y objetivos'
}];
export function ComparisonTable() {
  return <section className="py-10 md:py-20 bg-[#0F172A] px-4" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <div className="text-center mb-8 md:mb-12" data-id="element-68">
          <h2 className="font-display text-3xl md:text-5xl text-white mb-2 md:mb-4 uppercase" data-id="element-69">
            LA REALIDAD
          </h2>
          <p className="text-base md:text-lg text-gray-400 font-medium" data-id="element-70">
            ¿Cuánto te cuesta NO tenerlo?
          </p>
        </div>

        <div className="bg-gray-800 rounded-xl md:rounded-2xl shadow-xl border border-gray-700 overflow-hidden" data-id="element-71">
          <div className="grid grid-cols-2 bg-gray-900 border-b border-gray-700" data-id="element-72">
            <div className="p-3 md:p-6 text-center border-r border-gray-700" data-id="element-73">
              <h3 className="font-bold text-red-400 text-xs md:text-xl uppercase tracking-wide" data-id="element-74">
                Sin el sistema
              </h3>
            </div>
            <div className="p-3 md:p-6 text-center bg-cancha/10" data-id="element-75">
              <h3 className="font-bold text-gold text-xs md:text-xl uppercase tracking-wide" data-id="element-76">
                Con el sistema
              </h3>
            </div>
          </div>

          <div className="divide-y divide-gray-700" data-id="element-77">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-gray-800/50 transition-colors" data-id="element-78">
                <div className="p-3 md:p-6 border-r border-gray-700 flex items-start gap-2 md:gap-3" data-id="element-79">
                  <X className="text-red-400 shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" strokeWidth={3} data-id="element-80" />
                  <p className="text-[11px] md:text-base text-gray-400 font-medium leading-snug" data-id="element-81">
                    {row.sin}
                  </p>
                </div>
                <div className="p-3 md:p-6 flex items-start gap-2 md:gap-3 bg-cancha/[0.06]" data-id="element-82">
                  <Check className="text-gold shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" strokeWidth={3} data-id="element-83" />
                  <p className="text-[11px] md:text-base text-white font-bold leading-snug" data-id="element-84">
                    {row.con}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}